import { render, staticRenderFns } from "./InOtherCall.vue?vue&type=template&id=61f518ce&"
import script from "./InOtherCall.vue?vue&type=script&lang=js&"
export * from "./InOtherCall.vue?vue&type=script&lang=js&"
import style0 from "./InOtherCall.vue?vue&type=style&index=0&id=61f518ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports